module.exports = __webpack_public_path__ + "static/media/live_event.4a53c6ae.png";